import React, {useRef, useState} from 'react';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import {useDevice} from 'client/common/hooks/device';
import ShareButton from 'client/common/components/survey-preview/components/share-button';
import {Button, Modal} from 'client/common/components/lego';
import {getSurveyPreviewLink} from 'client/common/utils/survey-link';
import {useSurveyScope} from 'client/common/hooks/survey';
import {useSurveyPreset} from 'client/common/hooks/box';
import {Device} from 'client/common/utils/device-width';

import PhoneIcon from './icons/phone.svg';
import TabletIcon from './icons/tablet.svg';
import ReloadLightIcon from './icons/reload-light.svg';
import ReloadDarkIcon from './icons/reload-dark.svg';

import {ComponentProps, PreviewDevice} from './types';

import './preview.css';

const b = b_.with('preview');

const i18n = I18N.surveyPreview.preview;

const DEVICE_ICONS = {
    [PreviewDevice.Mobile]: PhoneIcon,
    [PreviewDevice.Desktop]: TabletIcon
};

const meaningfulClassName = b('device-select');

export const previewMeaningfulSelector = `.${meaningfulClassName}`;

export default function Preview(props: ComponentProps) {
    const {onClose, slug} = props;

    const device = useDevice();

    const [selectedDevice, setSelectedDevice] = useState(PreviewDevice.Mobile);

    const iframe = useRef<HTMLIFrameElement>(null);

    const reloadIframe = () => {
        if (iframe.current) {
            iframe.current.src = iframe.current.src;
        }
    };

    const scope = useSurveyScope();
    const preset = useSurveyPreset(slug!);
    const previewURL = getSurveyPreviewLink({slug: slug!, device: 'desktop', scope, preset});

    return (
        <Modal className={b()} visible>
            <div className={b('content')}>
                <div className={meaningfulClassName}>
                    {[PreviewDevice.Mobile, PreviewDevice.Desktop].map(previewDevice => (
                        <button
                            key={previewDevice}
                            className={b('device-icon', {
                                type: previewDevice,
                                active: previewDevice === selectedDevice ? 'yes' : 'no'
                            })}
                            onClick={() => setSelectedDevice(previewDevice)}
                        >
                            <img src={DEVICE_ICONS[previewDevice]} />
                        </button>
                    ))}
                </div>
                <div className={b('device', {type: selectedDevice})}>
                    <iframe className={b('iframe')} ref={iframe} src={previewURL} />
                </div>
                {onClose && (
                    <div className={b('close-button')} onClick={onClose} title={i18n.close} />
                )}
            </div>
            <div className={b('buttons')}>
                <ShareButton mix={b('button')} slug={slug} />
                <Button
                    className={b('button')}
                    view='default'
                    title={i18n.restart}
                    size='m'
                    onClick={reloadIframe}
                >
                    <img
                        src={device === Device.Mobile ? ReloadDarkIcon : ReloadLightIcon}
                        className={b('reload-icon')}
                    />
                    <span>{i18n.restart}</span>
                </Button>
            </div>
        </Modal>
    );
}
